import { ComparisonTable } from "./ComparisonTable";

export const UniversalRender = ComparisonTable;
